import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'

export interface GridPrefs {
  columnOrder?: string[]
  columnVisibility?: Record<string, boolean>
  sort?: { column: string; direction: 'asc' | 'desc' }
  columnWidths?: Record<string, number>
}

export function useGridPrefs(gridId: string) {
  return useQuery({
    queryKey: ['grid-prefs', gridId],
    queryFn: async () => {
      try {
        const { data } = await api.get<{ prefs: GridPrefs }>(`/v1/users/grid-prefs/${gridId}`)
        return data.prefs as GridPrefs
      } catch {
        // Return empty prefs on error (grid will use defaults)
        return {} as GridPrefs
      }
    },
    staleTime: 60000,
    retry: 1,
  })
}

export function useSaveGridPrefs() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ gridId, prefs }: { gridId: string; prefs: GridPrefs }) => {
      await api.put('/v1/users/grid-prefs', { grid_id: gridId, prefs })
    },
    onSuccess: (_, vars) => {
      qc.setQueryData(['grid-prefs', vars.gridId], vars.prefs)
    },
  })
}
